module.exports = __webpack_public_path__ + "img/796da5608cf45573ceedc79f31684c6e.png";